import type { SelectOption } from '@/shared/ui/select';

/**
 * The closed vocabularies the catalogue and the proposals share.
 *
 * These are the DOMAIN's words, not the console's: the attribute kinds and the
 * variant axes are the API's own enums, and a select that offered anything
 * else would offer a value the API refuses.
 */
export const ATTRIBUTE_KIND_OPTIONS: SelectOption[] = [
  { value: 'text', label: 'Text' },
  { value: 'single_select', label: 'Single select' },
  { value: 'multi_select', label: 'Multi select' },
  { value: 'boolean', label: 'Yes or no' },
  { value: 'date', label: 'Date' },
];

export const VARIANT_AXIS_OPTIONS: SelectOption[] = [
  { value: 'none', label: 'None — describes the product' },
  { value: 'size', label: 'Size' },
  { value: 'colour', label: 'Colour' },
  { value: 'material', label: 'Material' },
];

/**
 * The parent choices for a category.
 *
 * Every category this page created is offered alongside the ones that already
 * existed, because a merchant building a tree wants both.
 */
export function parentCategoryOptions(
  existing: ReadonlyArray<{ categoryId: string; name: string }>,
  created: ReadonlyArray<{ categoryId: string; name: string }>,
): SelectOption[] {
  return [
    { value: '', label: 'No parent — a top-level category' },
    ...existing.map((category) => ({ value: category.categoryId, label: category.name })),
    ...created.map((category) => ({ value: category.categoryId, label: `${category.name} (new)` })),
  ];
}
